import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import { styled } from '@mui/material';

// Styled Accordion with transparent background and no shadow
export const StyledAccordion = styled(Accordion)({
  backgroundColor: 'transparent',
  boxShadow: 'none',
  backgroundImage: 'none',
  '&:before': {
    display: 'none',
  },
  '&:after': {
    display: 'none',
  },
  '&.Mui-expanded': {
    boxShadow: 'none',
    margin: 0,
  },
  '&.MuiAccordion-root': {
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
  },
});

export const TwoColumnContainer = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 16,
});

export const ColumnContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const StyledColumnTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const StyledFormBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const StyledFormTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const StyledNoFormBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
}));

export const StyledFormComparisonBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const DLStyle = styled('dl')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '[question] 2fr [answer] 2fr',
  columnGap: theme.spacing(5),
  '& dt': {
    display: 'inline',
    ...theme.typography.body2,
  },
  '& dd': {
    display: 'inline-flex',
    flexDirection: 'row',
    ...theme.typography.body2,
    textAlign: 'left',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  '& dd:after': {
    content: '" "',
    display: 'block',
  },
}));
